import * as z from "zod";

export const FlattenedCustomerVariantPreferencesSchema = z.array(
  z.object({
    categoryName: z.string(),
    optionName: z.string(),
    count: z.number(),
  }),
);
export type FlattenedCustomerVariantPreferences = z.infer<
  typeof FlattenedCustomerVariantPreferencesSchema
>;

export type CustomerVariantPreferences = Map<string, number>;

export function buildCustomerVariantPreferences(
  flattenedCustomerVariantPreferences: FlattenedCustomerVariantPreferences,
): CustomerVariantPreferences {
  const customerVariantPreferences = new Map<string, number>();
  for (const preference of flattenedCustomerVariantPreferences) {
    const key = getCustomerVariantPreferenceKey(
      preference.categoryName,
      preference.optionName,
    );
    const existingCount = customerVariantPreferences.get(key) ?? 0;
    customerVariantPreferences.set(key, existingCount + preference.count);
  }

  return customerVariantPreferences;
}

export function getCustomerVariantPreferenceKey(
  categoryName: string,
  optionName: string,
): string {
  return `c:${categoryName} o:${optionName}`;
}
